import { Tab, Tabs, Card, CardBody } from "@heroui/react"
import { MainContainer } from "../../components"
import { DashboardPayable } from "./DashboardPayable"
import { DashboardReceivable } from "./DashboardReceivable"
import { useSelector } from "react-redux"
import { DashboardCombineOutstanding } from "./DashboardCombineOutstanding"
import { ENUM_ENCRYPT_CODE } from "../../constants/enum"
const DashboardOutstanding = () => {
  const outPData = useSelector((state) => state.outstandingPayable)
  const outRData = useSelector((state) => state.outstandingReceivable)

  let tabs = [
    {
      id: "Payable",
      label: "Payable",
      content: <DashboardPayable />
    },
    {
      id: "Receivable",
      label: "Receivable",
      content: <DashboardReceivable />
    },
    {
      id: "CombineOutStanding",
      label: "Combine",
      content: <DashboardCombineOutstanding />
    }
  ]

  return (
    <div>
      <div className="flex w-full flex-col">
        <Tabs aria-label="Dynamic tabs" color="danger" variant="underlined"  radius="none" items={tabs} 
          //defaultSelectedKey={"Payable"}
            //</div>(outPData && outPData.isFromDashboard ) ? "Payable"
           //: (outRData && outRData?.isFromDashboard ) ? "Receivable" :
              //() ? "CombineOutStanding" :
               // ""}
        >
          {(item) => (
            <Tab key={item.id}  title={item.label}>
              {item.content}
            </Tab>
          )}
        </Tabs>
      </div>

    </div>
  )
}
export default DashboardOutstanding
